<template>
    <v-dialog
        class="explainer"
        :value="show"
        persistent
        max-width="500px"
        overlay-color="#909090"
        overlay-opacity="1"
    >
        <v-card class="rounded-lg">
            <explanatory-carousel
                v-if="showCarousel"
                :show.sync="showCarousel"
                @close="close"
            />
            <confirmation v-else
                @proceed="close(true)"
                @close="close"
                @cancel="showCarousel = true"
             />
        </v-card>
    </v-dialog>
</template>

<script>
import ExplanatoryCarousel from './explanatory-carousel.vue';
import Confirmation from './confirmation.vue';

export default {
    components: { ExplanatoryCarousel, Confirmation },
    data() {
        return {
            showCarousel: true,
        }
    },
    props: {
        show: Boolean,
    },
    methods: {
        close(value) {
            this.showCarousel = true;
            this.$emit('close', value);
        },
    },
}
</script>

<style scoped>
>>> .v-dialog.v-dialog--active {
    background: transparent !important;
    box-shadow: none !important
}
</style>